import { useEffect, useState } from "react";
import {ApiUrl} from "../../ApiUrl"

const useFetchPickupPoints = (routeId) => {
  const [pickupPoints, setPickupPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPickupPoints = async () => {
      if (routeId) { 
        try {
          const url = `${ApiUrl.apiurl}Transport/GetAllPickupPointBasedOnRoute/${routeId}`;
          const response = await fetch(url);
          
          if (!response.ok) {
            throw new Error(`Failed to fetch pick-up points. Status: ${response.status}`);
          }

          const data = await response.json();
          setPickupPoints(data.data || []); 
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      } else {
        setPickupPoints([]); 
        setLoading(false);
      }
    };

    fetchPickupPoints();
  }, [routeId]);

  return { pickupPoints, loading, error };
};

export default useFetchPickupPoints;
